import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Formik, Field } from 'formik'
import { colors, w } from '../ui/helpers.js'
import { H1, H2, Text, Span, GradientFont, Error } from '../ui/Typography.js'
import { Flex, Box } from '../ui/Layout.js'
import Image from '../ui/Image.js'
import { Input } from '../ui/Input.js'
import Button from '../ui/Button.js'
import formikFormWrapper from '../formikFormWrapper.js'
import api from '../api.js'
import { useAuth } from '../Auth.js'
import Billing from './Billing.js'
import ChatButton from '../Components/ChatButton.js'
import baseUrl from '../baseUrl.js'

const LeftContainer = styled(Flex)`
  @media (max-width: 1240px) {
    width: 200px;
  }
  @media (max-width: 1150px) {
    display: none;
  }
`

const BillingPage = (props) => {
  let { user } = useAuth()
  const [error, setError] = useState('')
  const [search, setSearch] = useSearchParams()

  let navigate = useNavigate()
  console.log(user)
  return (
    <Flex justifyContent="center">
      <Image src="logo.svg" width="100px" position="absolute" top="16px" left="16px" />
      <Flex position="relative" flexDirection="column" alignItems="center" width="100%" p="76px" maxWidth="1400px">
        <H1 mb="27px" textAlign="left" width="100%">
          Choose a plan
        </H1>
        <Billing
          redirectUrl={user.shopifyShopUrl ? `${baseUrl}/shopify-install` : `${baseUrl}/?welcomeFlow=true`}
          canAlwaysSelectFree
        />
      </Flex>
    </Flex>
  )
}

export default BillingPage
